import { getColormap, getColormapsList } from "./colormap.js";
import LookupTable from "./lookupTable.js";

const Color = {
  getColormap,
  getColormapsList,
  LookupTable
};

export default Color;
